import { Family, Parent, Student, Class, FamilyMember } from '@/types/models';
import { mapToBillingStatus, mapToInviteStatus } from '@/utils/typeUtils';

// Entity mappers to ensure proper type conversion from database to app models

export const mapFamilyFromSupabase = (data: any): Family => {
  return {
    id: data.id,
    organization_id: data.organization_id,
    name: data.name,
    billing_status: mapToBillingStatus(data.billing_status),
    created_at: data.created_at
  };
};

export const mapParentFromSupabase = (data: any): Parent => {
  return {
    id: data.id,
    user_id: data.user_id,
    family_id: data.family_id,
    organization_id: data.organization_id,
    first_name: data.first_name,
    last_name: data.last_name,
    phone: data.phone || '',
    email: data.email || '',
    invite_status: mapToInviteStatus(data.invite_status),
    is_primary: data.is_primary || false,
    created_at: data.created_at,
    // Address fields
    address_street: data.address_street || undefined,
    address_city: data.address_city || undefined,
    address_state: data.address_state || undefined,
    address_zip: data.address_zip || undefined,
    address_country: data.address_country || 'United States',
    // Status fields
    is_active: data.is_active !== false, // Default to true if not defined
    is_deleted: data.is_deleted || false,
    deleted_at: data.deleted_at || undefined
  };
};

export const mapStudentFromSupabase = (data: any): Student => {
  return {
    id: data.id,
    family_id: data.family_id,
    organization_id: data.organization_id,
    first_name: data.first_name,
    last_name: data.last_name,
    preferred_name: data.preferred_name || undefined,
    date_of_birth: data.date_of_birth || undefined,
    gender: data.gender || undefined,
    notes: data.notes || undefined,
    created_at: data.created_at,
    
    // Contact information
    address_line1: data.address_line1 || undefined,
    address_line2: data.address_line2 || undefined,
    city: data.city || undefined,
    state: data.state || undefined,
    zip: data.zip || undefined,
    phone: data.phone || undefined,
    email: data.email || undefined,
    
    // Additional info
    location_id: data.location_id || undefined,
    profile_picture_url: data.profile_picture_url || undefined,
    start_date: data.start_date || undefined,
    drop_date: data.drop_date || undefined,
    is_active: data.is_active,
    no_public_photos: data.no_public_photos
  };
};

export const mapClassFromSupabase = (data: any): Class => {
  return {
    id: data.id,
    organization_id: data.organization_id,
    name: data.name,
    description: data.description,
    max_students: data.max_students,
    location: data.location,
    dress_code: data.dress_code,
    level: data.level,
    price_cents: data.price_cents,
    season_id: data.season_id,
    is_active: data.is_active,
    is_event: data.is_event,
    event_date: data.event_date,
    event_start_time: data.event_start_time,
    event_end_time: data.event_end_time,
    created_at: data.created_at
  };
};

export const mapFamilyMemberFromSupabase = (data: any): FamilyMember => {
  return {
    id: data.id,
    family_id: data.family_id,
    user_id: data.user_id,
    role: data.role,
    invite_status: mapToInviteStatus(data.invite_status),
    is_primary_billing: data.is_primary_billing,
    can_edit_profile: data.can_edit_profile,
    invited_email: data.invited_email,
    created_at: data.created_at
  };
};
